import React, { Component, ReactNode } from 'react';

interface IErrorBoundaryProps {
  children: ReactNode;
}

interface IErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends Component<
  IErrorBoundaryProps,
  IErrorBoundaryState
> {
  constructor(props: IErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
    this.handleRefresh();
  }

  handleRefresh = () => {
    setTimeout(() => {
      this.setState({ hasError: false });
    }, 1000);
  };

  render() {
    if (this.state.hasError) {
      return null;
    }

    return <>{this.props.children}</>;
  }
}
